import { breadcrumbs } from './breadcrumbs';

export const shared = {
  namespaced: true,
  modules: {
    breadcrumbs
  }
};
